import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=32725396&scoped=true&"
import script from "./Money.vue?vue&type=script&lang=ts&"
export * from "./Money.vue?vue&type=script&lang=ts&"
import style0 from "./Money.vue?vue&type=style&index=0&id=32725396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.nlark.com+vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32725396",
  null
  
)

export default component.exports